import {useEffect, useState} from 'react'
import {Link, useNavigate, useParams, useLocation} from 'react-router-dom'
import {BasicLayout} from './Layouts/basicLayout'
import expiredToken from '../utils/headerAuth'
import './Reporte.css'
import axios from 'axios'
import moment from 'moment'
import {useGlobalContent} from '../context/helpersProvider'

export const Reporte = () => {
  const {setShowToast, setShowLoading} = useGlobalContent()
  const location = useLocation()
  const isFromEmail = location.search.includes('ref=email')

  interface params {
    id: string
  }
  const history = useNavigate()

  interface reportInterface {
    id: number
    name: string
    subtitle: string
    abstract_name: string
    abstract: string
    report_type: any
    categories: Array<any>
    author_name: string
    author_id: number
    publication_date: Date
    file_location: string
  }
  const [report, setReport] = useState<reportInterface>({
    id: 0,
    name: '',
    subtitle: '',
    abstract_name: '',
    abstract: '',
    report_type: {},
    categories: [],
    author_name: '',
    author_id: 0,
    file_location: '',
    publication_date: new Date(),
  }) 

  const handleToast = (type: string, message: string) => {
    setShowToast({ open: 'true', type, message })
  }
  const params = useParams();
  const id = params.id as string | undefined;

  useEffect(() => {
    if (localStorage.getItem('idClient') === null || id === undefined) {
      history('/')
    } else {
      let sessionId = localStorage.getItem('idClient')
      if (isFromEmail) {
        axios
          .get(`/report/viewEmail/${id}/${sessionId !== null && JSON.parse(sessionId)}`)
          .then((json) => json.data)
          .then((datos) => {
            if (datos.status === 200) {
              setReport(datos.data) 
            } else {
              handleToast('error', datos.message) 
              history('/home')
            }
          })
          .catch((error) => {
            console.log(error)
            expiredToken(history, error, setShowToast)
          })
      } else {
        axios
          .get(`/report/${id}/${sessionId !== null && JSON.parse(sessionId)}`)
          .then((json) => json.data)
          .then((datos) => { 
            if (datos.status === 200) {
              setReport(datos.data) 
            } else {
              handleToast('error', datos.message) 
              history('/home')
            }
          })
          .catch((error) => {
            console.log(error)
            expiredToken(history, error, setShowToast)
          })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const download = () => {
    let sessionId = localStorage.getItem('idClient')
    let data = {
      report_id: report.id,
      user_id: parseInt(sessionId !== null && JSON.parse(sessionId)),
    }
  
    setShowLoading('true')
    axios
      .post(`/user/file`, data, {responseType: 'blob'})
      .then((res) => {
        if (res.status === 200) {
          setShowLoading('false')
          const contentDisposition = res.headers['content-type']
          const filename = contentDisposition
  
          const url = window.URL.createObjectURL(
            new Blob([res.data], {type: 'application/pdf'}) // tipo de archivo correcto
          )
          
          // Abre el archivo en una nueva pestaña en lugar de descargarlo
          window.open(url, '_blank');
          
          console.log(res)
          setShowToast({
            open: 'true',
            message: 'File opened successfully',
            type: 'success',
          })
        } else {
          setShowToast({
            open: 'true',
            message: "Don't such file",
            type: 'error',
          })
        }
      })
      .catch((err) => {
        setShowLoading('false')
        expiredToken(history, err, setShowToast)
        return err
      })
  }

  
  return (
    <BasicLayout>
      <div className='content-div'>
        <div className='user-info-div'>
          <h4 className='h3-title'>
            {' '}
            <button onClick={() => history(-1)} className='back-button w-button' /> {'    '}
            Report Detail
          </h4>
        </div>
        <div className='actions-div'>
          <div className='tag-list'>
            {report?.categories?.map((e) => (
              <div key={e.id} className='tag'>
                {e.name}
              </div>
            ))}
          </div>
        </div>
        <div className='resumen'>
          <h1 className='tittle'>{report.name}</h1>
          <div className='line'></div>

          <h2 className='subtittle'>{report.subtitle}</h2>

          <h3 className='abstract_name'>{report.abstract_name}</h3>

          <pre
            className='resume-text'
            style={{whiteSpace: 'pre-wrap', height: 'fit-content', margin: 0,overflow: 'hidden' }}
          >
            {report.abstract}
          </pre>
        </div>
        <div className='actions-div'>
          <div>
            Published:
            <span className='span-text'>{report.author_name}</span>
            <span className='span-text'>
              {moment(report.publication_date).format('YYYY/MM/DD')}
            </span>
          </div>

          {report?.file_location !== null && report?.file_location !== '' && report?.file_location !== undefined ? (
            <button onClick={download} className='blue-short-btn download w-button'>
              Download Attachment
            </button>
          ) : (
            <div>This report has no attachment</div>
          )}
        </div>
      </div>
    </BasicLayout>
  )
}
